export default class Footer {
	constructor() {
		/** @type {HTMLButtonElement} */
		const btn = document.querySelector('button[data-manage-cookies]')
		const cookieBanner = document.querySelector('cookie-banner')

		btn.addEventListener('click', () => {
			cookieBanner?.promptForConsent()
		})
	}
}
